import { MAP_TYPES } from '@larki/shared/types/user.type';
import { z } from 'zod';

export const mapTypeEnum = z.enum(MAP_TYPES);
export type MapType = z.infer<typeof mapTypeEnum>;
